import {createSelector, Selector} from 'reselect';
import {get, groupBy, sortBy} from 'lodash';
import {ObjectOf, Store} from 'src/types/store';
import {ActivityGroupings} from './cardGroupings';
import {Activity} from 'src/types/activities';

interface GroupSettings {
  cardGroupingOrder: string[];
  cardGroupings: ObjectOf<{
    key: string;
    subtitle: string;
  }>;
}

export const getHighSchoolName = (state: Store): string => state.student.currentInstitution.name;

export const getCards: Selector<Store, Activity[]> = (state: Store) =>
  get(state, 'opportunityCards.cards', []);

export const getSortedOpportunityCardsSelector = createSelector<
  Store,
  Activity[],
  ObjectOf<Activity[]>
>([getCards], (cards) => {
  const groupedCards = groupBy(cards, 'cardInfo.group');

  for (const key in groupedCards) {
    groupedCards[key] = sortBy(groupedCards[key], 'cardInfo.rank');
  }

  return groupedCards;
});

export const getGroupSettings = (): GroupSettings => ({
  cardGroupingOrder: [ActivityGroupings.discovery.key],
  cardGroupings: {
    discovery: {
      ...ActivityGroupings.discovery,
      subtitle: '',
    },
  },
});

export const getCardCount = createSelector(getSortedOpportunityCardsSelector, (groupedCards) =>
  Object.keys(groupedCards).reduce((count, key) => groupedCards[key].length + count, 0)
);
